
import { computed, defineComponent, PropType } from 'vue'
import { useStore } from '@/store'
import { ElementTypes, PPTElement, Slide } from '@/types/slides'
// 修改
import BaseAudioElement from '@/views/componentsnotesView/element/AudioElement/BaseAudioElement.vue'
import BaseVideoElement from '@/views/componentsnotesView/element/VideoElement/BaseVideoElement.vue'
import BaseImageElement from '@/views/componentsnotesView/element/ImageElement/BaseImageElement.vue'
import BaseTextElement from '@/views/componentsnotesView/element/TextElement/BaseTextElement.vue'
import BaseShapeElement from '@/views/componentsnotesView/element/ShapeElement/BaseShapeElement.vue'
import BaseLineElement from '@/views/componentsnotesView/element/LineElement/BaseLineElement.vue'
import ScreenChartElement from '@/views/componentsnotesView/element/ChartElement/ScreenChartElement.vue'
import BaseTableElement from '@/views/componentsnotesView/element/TableElement/BaseTableElement.vue'

export default defineComponent({
  name: 'screen-element',
  props: {
    elementInfo: {
      type: Object as PropType<PPTElement>,
      required: true,
    },
    elementIndex: {
      type: Number,
      required: true,
    },
    animationIndex: {
      type: Number,
      default: -1,
    },
  },
  setup(props) {
    const currentElementComponent = computed(() => {
      const elementTypeMap = {
        [ElementTypes.AUDIO]: BaseAudioElement,
        [ElementTypes.VIDEO]: BaseVideoElement,
        [ElementTypes.IMAGE]: BaseImageElement,
        [ElementTypes.TEXT]: BaseTextElement,
        [ElementTypes.SHAPE]: BaseShapeElement,
        [ElementTypes.LINE]: BaseLineElement,
        [ElementTypes.CHART]: ScreenChartElement,
        [ElementTypes.TABLE]: BaseTableElement,
      }
      return elementTypeMap[props.elementInfo.type] || null
    })

    const store = useStore()
    const theme = computed(() => store.state.theme)
    const currentSlide = computed<Slide>(() => store.getters.currentSlide)

    // 判断元素是否需要等待执行入场动画：等待执行的元素需要先隐藏
    const needWaitAnimation = computed(() => {
      const animations = currentSlide.value.animations || []
      const elementIndexInAnimation = animations.findIndex(animation => animation.elId === props.elementInfo.id)
      if (elementIndexInAnimation !== -1 && elementIndexInAnimation >= props.animationIndex) return true
      return false      
    })

    return {
      currentElementComponent,
      needWaitAnimation,
      theme,
    }
  },
})
